import MoneyHero from "./../common/hero";
import { FormProvider } from "./../context/waitlist-context";
import CalculatorsAndTools from "../tools";
import { BackButtonIcon } from "../../../icons/academy-icons";
import { Link } from "react-router-dom";
import { MODAL_NAME } from "../../../constants";
import BecomeMember from "../../common/membership";
import { useAppSelector } from "../../../hooks/store-hooks";

const header = {
  title: "Simplify your tax filing",
  button: "File ITR",
  subText: "File your taxes quickly and easily.",
  bgImage: "/assets/money/rings.webp",
  image: "/assets/money/tax/tax_banner.webp",
  redirectUrl: `${window.location.origin}/money/protect/tax/file-itr`,
  theme: "#007aff",
  textColor: "text-white",
  imageClass: "!w-[205px] !h-[196px] !mr-10",
};
const TaxComponent = () => {
  const { modalName } = useAppSelector((state) => state.modal);
  return (
    <div className="flex flex-col gap-8 w-[70%]">
      <FormProvider>
        <div className="font-bold text-3xl flex gap-8 items-center">
          <Link to="/money/protect">
            <BackButtonIcon width={20} height={20} />
          </Link>
          <p>Tax</p>
        </div>
        <MoneyHero data={header} />
        <div className="mb-8">
          <CalculatorsAndTools />
        </div>
      </FormProvider>
      {modalName === MODAL_NAME.BECOME_MEMBER && <BecomeMember />}
    </div>
  );
};

export default TaxComponent;
